import Experiments from '@alltrails/core/types/Experiments';

const getDefaultTierSelected = (postAuthXp: Experiments['web-growth-rm-single-dual-tier-post-auth-upsell'], isPlus?: boolean) => {
  const contentVariant = postAuthXp?.value;

  if (isPlus) {
    return 'peak';
  }

  if (contentVariant === 'plus_only' || contentVariant === 'plus_default') {
    return 'plus';
  }

  return 'peak';
};

export default getDefaultTierSelected;
